export enum Flow {
    KYC = "kyc",
    ONRAMP = "onramp",
    OFFRAMP = "offramp",
}